export default __webpack_public_path__ + "static/media/createWhiteMode.476e6bf7.svg";